<script>
  import {beta} from '../../../../lib/beta/beta';
  import VideoTracking from '../VideoTracking/VideoTracking.svelte';
</script>

<div>
  <VideoTracking />
</div>
